import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Globle } from 'src/assets/globle';
import { Mandoob } from '../mandoob.model';
import { MandoobService } from '../mandoob.service';

@Component({
  selector: 'app-mandoobslist',
  templateUrl: './mandoobslist.component.html',
  styleUrls: ['./mandoobslist.component.css'],
  queries: {
    contentRef: new ViewChild("Modal")
  },
})
export class MandoobslistComponent implements OnInit {

  mandoobs: Mandoob[] = [];
  displayedColumns: string[] = ['id', 'name', 'canUpdateUserCategory', "edit", "delete"];
  dataSource!: MatTableDataSource<Mandoob>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  spinnerOverlay = false
  public contentRef!: TemplateRef<any>;
  mandoob: Mandoob = {} as Mandoob;
  Advstatus: { id: number, name: string }[] = [];
  selectedStatus: number = 1
  pageSize = 100;
  constructor(private service: MandoobService,
    private router: Router,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private globle: Globle,
    private translate: TranslateService) { }

  ngOnInit() {
    this.pageSize = this.globle.pageSize;
    this.get();
  }

  get() {
    this.spinnerOverlay = true;
    this.service.getAll().subscribe(data => {
      this.mandoobs = data.sort((n1, n2) => n2.id - n1.id);
      this.dataSource = new MatTableDataSource(this.mandoobs);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.spinnerOverlay = false;
    },
      error => {
        this.spinnerOverlay = false;
        console.log(error);
      })
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  createNew() {
    this.router.navigate(['./master/options/addMandoob']);
  }

  edit(id: number) {
    this.router.navigate(['./master/options/editMandoob/' + id]);
  }

  onDelete(id: number) {
    this.mandoob.id = id;
    this.openDialog();
  }

  delete() {
    this.spinnerOverlay = true;
    this.dialog.closeAll();
    this.service.Delete(this.mandoob.id).subscribe(data => {
      this.openSnackBar(this.translate.instant("deletedSuccessfully"), 'snackBarSuccess');
      this.spinnerOverlay = false;
      this.get();
    },
      error => {
        console.log(error);
        this.spinnerOverlay = false;
        this.dialog.closeAll();
        if (error.error.message) {
          this.openSnackBar(error.error.message, "snackBarError");
        }
        else {
          this.openSnackBar("Internal server error", "snackBarError");
        }
      })
  }

  confirmDelete() {
    this.delete();
  }

  openSnackBar(message: string, cssclass: string) {
    this.snackBar.open(message, 'Close', {
      duration: 6000,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass: cssclass
    });
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(this.contentRef, {
      width: '300px',
    });
  }

  onNoClick(): void {
    this.dialog.closeAll();
  }

  selectChange() {
    this.get();
  }

}
